import { InvoiceTaskDocument } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';


/**
 * 1920. 請求タスクファイル名編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_documents/:invoice_task_document_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
  name: string;
};

const updateInvoiceTaskDocument = (props: Props): Promise<InvoiceTaskDocument> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_documents/${props.id}`,
    props
  );
};

export const useUpdateInvoiceTaskDocument = () => {
  return useMutation({
    mutationFn: updateInvoiceTaskDocument
  });
};
